import React from "react";

import type {
    ResourcesDownloadsPanelBlock as PanelValue,
    ServerCmsModelsSnippetsProductProductDocument as ProductDocumentProps,
    ResourcesDownloadsBlock as Value,
} from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { Themed } from "../../styles/themes";
import { RichTextStreamBlock } from "../RichTextStreamBlock";
import { SpacerBlock } from "../SpacerBlock";
import { DownloadsPanel } from "./DownloadsPanel";

interface Props {
    value: Value;
    documents: ProductDocumentProps[];
    downloadsUrl: string;
}

export const ResourcesDownloadsBlock = ({
    value,
    documents,
    downloadsUrl,
}: Props) => {
    if (!value.items) return <></>;

    const components = {
        rich_text_stream: RichTextStreamBlock,
        spacer: SpacerBlock,
        downloads: ({ value }: { value: PanelValue }) => (
            <DownloadsPanel
                value={value}
                documents={documents}
                downloadsUrl={downloadsUrl}
            />
        ),
    };

    return (
        <Themed theme={value.theme} tag="section">
            <StreamField
                tagName={React.Fragment}
                components={components}
                value={value.items}
            />
        </Themed>
    );
};
